export default __webpack_public_path__ + "static/ikm-01d8fe55a340ed26b6c6457a55926eea.jpg";